// extracted by mini-css-extract-plugin
export default {"header":"Retexes_header__IkLsH","title":"Retexes_title__xcrQf"};